<template>
  <div class="not-found">
    <div class="not-found__inner">
      <p class="not-found__code">404</p>
      <h1 class="not-found__title">Страница не найдена</h1>
      <p class="not-found__descr">
        Такой страницы не существует: возможно, в&nbsp;адресе опечатка <br/>или страница переехала.
        Начните с&nbsp;главной или загляните в&nbsp;Какао-академию.
      </p>
      <div class="not-found__buttons">
        <router-link to="/">На главную</router-link>
        <router-link to="/kakao-academy" class="_bordered">В Какао-академию</router-link>
      </div>
    </div>
    <img src="@/assets/img/bob3.png" alt="" class="not-found__bob"/>
  </div>
</template>
